/* shto-full-formula: the progress bar under the phone carousel. The blue part keeps its Figma size and slides from the
   start of the grey track to its end as the cards move (swiped with assets/shto-swipe.js, which moves scrollLeft, so the
   scroll event follows every drag). Runs once for every copy of the section. */
(function () {
  if (window.ShtoFullFormula) return;
  window.ShtoFullFormula = true;

  function init(section) {
    var cards = section.querySelector('[data-shto-full-formula-cards]');
    var bar = section.querySelector('[data-shto-full-formula-bar]');
    if (!cards || !bar || cards.shtoProgress) return;
    cards.shtoProgress = true;
    var queued = false;
    function update() {
      queued = false;
      var max = cards.scrollWidth - cards.clientWidth;
      var track = bar.parentElement.clientWidth - bar.offsetWidth;
      var share = max > 0 ? Math.min(1, Math.max(0, cards.scrollLeft / max)) : 0;
      bar.style.setProperty('--shto-progress', Math.round(share * track * 100) / 100 + 'px');
    }
    function queue() { if (!queued) { queued = true; requestAnimationFrame(update); } }
    cards.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    update();
  }

  function initAll(root) { (root || document).querySelectorAll('[data-shto-section="shto-full-formula"]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
